import { render, staticRenderFns } from "./PatientDetailsList.vue?vue&type=template&id=c494f1aa&scoped=true"
import script from "./PatientDetailsList.vue?vue&type=script&lang=js"
export * from "./PatientDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c494f1aa",
  null
  
)

export default component.exports